import { Component, OnInit, Input } from "@angular/core";
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { State, Section, Page } from "../../../../../../common/models/flow.dto";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-payment-checkout-data-config",
    templateUrl: "./payment-checkout-data-config.component.html",
    standalone: false
})
export class PaymentCheckoutDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "PaymentCheckoutDataConfigComponent";

    selectedState: State;

    constructor(public readonly contextService: ContextInteractionService) { super(contextService);  }

    ngOnInit() {
        
    }

    getPagesForSection(): Page[] {
        if (this.componentData.config.responseSection === undefined || this.componentData.config.responseSection === null) return [];
        const index = this.componentData.config.responseSection;
        return this.selectedState.sections[index].pages;
    }

    getPageTitle(page: Page, index: number): string {
        return (page.subtitle) ? `${page.subtitle} - Page ${index}` : `Page ${index}`;
    }

    getSectionName(section: Section, index: number): string {
        return (section.name) ? `${section.name} - Section ${index}` : `Section ${index}`;
    }

    sectionChanged(): void {
        this.componentData.config.responsePage = 0;
    }
}
